<!--博物馆主题活动-分页列表(公用)-->
<template>
    <div class="museum-act-page-container">
        <!-- 标题区 -->
        <div class="museum-act-page-header">
            <div class="museum-act-page-title-box">
                <div class="museum-act-page-title">{{itemInfo.itemMonth}} {{itemInfo.itemName}}</div>
                <div class="museum-act-page-subtitle">{{itemInfo.itemDesc}}</div>
            </div>
            <div class="museum-act-back-btn" @click="backPage">⇦返回</div>
        </div>

        <!-- 筛选工具栏 -->
        <div class="museum-act-page-filter">
            <div class="filter-left">
                <div class="filter-item">
                    <span class="filter-label">学段</span>
                    <el-select class="filter-select" v-model="queryParams.periodKey" clearable placeholder="请选择" @change="handleFilterChange">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey"/>
                    </el-select>
                </div>
                <div class="filter-item">
                    <span class="filter-label">年级</span>
                    <el-select class="filter-select" v-model="queryParams.activityGrade" clearable placeholder="请选择" @change="handleFilterChange">
                        <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey"/>
                    </el-select>
                </div>
            </div>
            <div class="filter-right">
                <input class="museum-act-search-input" type="text" placeholder="请输入关键词" v-model="queryParams.activityName" @keyup.enter="handleSearch"/>
                <div class="museum-act-search-btn" @click="handleSearch">搜索</div>
            </div>
        </div>

        <!-- 活动列表 -->
        <div class="museum-act-list" v-loading="loading">
            <div class="museum-act-card" v-for="(item,index) in activityList" :key="index" @click="handleActivityClick(item)">
                <div class="museum-act-cover">
                    <img :src="item.activityCover" :alt="item.activityName"/>
                </div>
                <div class="museum-act-info">
                    <div class="museum-act-info-item" :title="item.activityName">
                        <span class="info-label">活动主题：</span>
                        <span class="info-value">{{item.activityName}}</span>
                    </div>
                    <div class="museum-act-info-item" :title="(item.periodName || '') + '·' + (item.activityGradeName || '')">
                        <span class="info-label">学段年级：</span>
                        <span class="info-value">{{item.periodName}}·{{item.activityGradeName}}</span>
                    </div>
                    <div class="museum-act-info-item">
                        <span class="info-label">活动时长：</span>
                        <span class="info-value">{{item.activityTime}}</span>
                    </div>
                </div>
            </div>
            <div class="museum-act-empty" v-if="!loading && activityList.length===0">
                <dataEmpty title="暂无数据"/>
            </div>
        </div>

        <!-- 分页 -->
        <div class="museum-act-pagination" v-if="total > 0">
            <pageTag :background="true"
                     :pageSizes="[12, 24, 36]"
                     :total="total"
                     v-model:page.sync="queryParams.pageNum"
                     v-model:limit.sync="queryParams.pageSize"
                     @pagination="pageList"/>
        </div>
    </div>
</template>

<script>
import {pageMuseumActivity, queryDict} from "@/api/admin/museum";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";

export default {
    name: "museumActivityPage",
    components: {dataEmpty, pageTag},
    data() {
        return {
            loading:false,
            total:0,
            activityList:[],
            periodList:[],
            gradeList:[],
            /*分页查询主题活动*/
            queryParams:{
                activityName:'',
                activityItem:'',
                periodKey:'',
                museumKey:'',
                activityGrade:'',
                pageNum: 1,
                pageSize: 12,
            },
        }
    },
    computed: {},
    props:{
        itemInfo:{
            type: Object,
            default: () => ({})
        },
        museumKey:{
            type: String,
            default:''
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.initQuery();
        },
    },
    created() {
        this.handleQueryDict();
        this.initQuery();
    },
    mounted(){},
    methods: {
        /*初始化查询条件并查询*/
        initQuery(){
            if (!this.itemInfo.itemId) return;
            this.queryParams.activityName = '';
            this.queryParams.periodKey = '';
            this.queryParams.activityGrade = '';
            this.queryParams.pageNum = 1;
            this.queryParams.activityItem = this.itemInfo.itemId;
            this.queryParams.museumKey = this.museumKey;
            this.pageList();
        },
        /*字典查询*/
        handleQueryDict() {
            queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data || [];
                }
            });
            queryDict({ code: "grade_period" }).then(res => {
                if (res.data.code === 1) {
                    this.gradeList = res.data.data || [];
                }
            });
        },
        /*活动分页查询*/
        pageList(e) {
            this.loading = true;
            this.activityList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageMuseumActivity(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total || 0;
                    this.activityList = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /*筛选与搜索*/
        handleFilterChange() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleActivityClick(item){
            this.$emit('view-info', item);
        },
        backPage(){
            this.$emit('back-page');
        }
    }
}
</script>

<style scoped>
.museum-act-page-container{
    width: 100%;
    height: 100%;
    padding: 10px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.museum-act-page-header{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.museum-act-page-title-box{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.museum-act-page-title{
    font-weight: bold;
    color: #0d55a4;
    font-size: 18px;
    line-height: 1.4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.museum-act-page-subtitle{
    color: #9a9a9a;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.museum-act-back-btn{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

/* 筛选工具栏 */
.museum-act-page-filter{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.filter-left{
    display: flex;
    align-items: center;
    gap: 24px;
}
.filter-item{
    display: flex;
    align-items: center;
    gap: 10px;
}
.filter-label{
    font-size: 14px;
    color: #4b5563;
}
.filter-select{
    width: 120px;
}
.filter-select :deep(.el-select__wrapper){
    min-height: 32px;
    font-size: 14px;
}
.filter-right{
    display: flex;
    align-items: center;
    gap: 10px;
}
.museum-act-search-input{
    width: 200px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    box-sizing: border-box;
    background-color: #ffffff;
}
.museum-act-search-input:focus{
    border-color: #0d55a4;
}
.museum-act-search-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    border: 1px solid #0d55a4;
    border-radius: 6px;
    font-size: 14px;
    color: #0d55a4;
    background-color: #ffffff;
    cursor: pointer;
    box-sizing: border-box;
}
.museum-act-search-btn:hover{
    background-color: #0d55a4;
    color: #ffffff;
}

/* 活动列表 */
.museum-act-list{
    flex: 1;
    min-height: 0;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    align-content: flex-start;
    padding-top: 4px;
}
.museum-act-card{
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #0d55a4;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 12px;
    cursor: pointer;
    transition: all 0.25s ease;
}
.museum-act-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.museum-act-cover{
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 12px;
    background-color: #f3f4f6;
    border-radius: 6px;
}
.museum-act-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.museum-act-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.museum-act-info-item{
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.info-label{
    color: #4b5563;
}
.info-value{
    color: #1f2937;
}
.museum-act-empty{
    grid-column: 1 / -1;
    width: 100%;
}

/* 分页 */
.museum-act-pagination{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 12px;
}
</style>
